export default { sha: '2e6b6964d7a0b1a32c4d3dec92732dc49d2fa9d5', buildNumber: 'undefined' }
